import { ReduxWrapper } from "../app.state";
import { ITemplateInstallationRequest } from "src/app/models/template-installation-requests.model";

export const templateInstallationRequestsInitialState: ReduxWrapper<ITemplateInstallationRequest[]> = {
    error: undefined,
    loadedOnce: false,
    loading: false,
    value: []
};
